(function () {
  // ---- Konfiguration ----
  var EXCLUDED   = [''];
  var BAR_COLOR  = '#e77f6e';   // Hintergrund
  var TEXT_COLOR = '#ffffff';
  var COOKIE_DAYS = 30;

  // ---- Cookie-Helfer ----
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value || '') + expires + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (acc, c) {
      var p = c.split('=');
      return p[0] === name ? decodeURIComponent(p[1]) : acc;
    }, null);
  }

  // ---- /discount/CODE: Code merken + weiterleiten ----
  var match = window.location.pathname.match(/\/discount\/([^\/?#]+)/);
  if (match) {
    setCookie('discount_code', decodeURIComponent(match[1]), COOKIE_DAYS);
    var redirect = new URLSearchParams(window.location.search).get('redirect');
    window.location.href = redirect || '/';
    return;
  }

  // ---- Banner anzeigen ----
  var code = getCookie('discount_code');
  if (!code || EXCLUDED.indexOf(code) !== -1) return;
  if (sessionStorage.getItem('discount_banner_dismissed')) return;

  function renderBanner() {
    if (document.getElementById('discount-banner')) return;

    var style = document.createElement('style');
    style.textContent =
      '#discount-banner{background:' + BAR_COLOR + ';color:' + TEXT_COLOR + ';' +
        'font:500 14px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;' +
        'display:flex;align-items:center;justify-content:center;gap:8px;' +
        'padding:11px 44px;text-align:center;position:relative;z-index:1000;' +
        'animation:dbSlide .35s ease}' +
      '#discount-banner b{font-weight:700;letter-spacing:.02em}' +
      '#discount-banner .db-close{position:absolute;right:14px;top:50%;' +
        'transform:translateY(-50%);background:none;border:0;color:inherit;' +
        'font-size:20px;line-height:1;cursor:pointer;opacity:.7;' +
        'transition:opacity .2s;padding:4px}' +
      '#discount-banner .db-close:hover{opacity:1}' +
      '@keyframes dbSlide{from{transform:translateY(-100%)}to{transform:translateY(0)}}' +
      '@media (prefers-reduced-motion:reduce){#discount-banner{animation:none}}';
    document.head.appendChild(style);

    var bar = document.createElement('div');
    bar.id = 'discount-banner';

    var text = document.createElement('span');
    text.append('Dein Code ');
    var strong = document.createElement('b');
    strong.textContent = code;            // textContent -> keine HTML-Injection
    text.append(strong, ' ist aktiviert ✓');

    var close = document.createElement('button');
    close.className = 'db-close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Hinweis schließen');
    close.textContent = '×';
    close.addEventListener('click', function () {
      bar.remove();
      sessionStorage.setItem('discount_banner_dismissed', 'true');
    });

    bar.append(text, close);
    document.body.insertBefore(bar, document.body.firstChild);
  }

  if (document.body) renderBanner();
  else document.addEventListener('DOMContentLoaded', renderBanner);
})();